// extracted by mini-css-extract-plugin
module.exports = {"bg":"XyzPlusDashboardHead__bg__319UC"};